import { FC, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './Typography.module.scss';

enum Typographies {
  TEXT_EDITOR_TITLE = 'text-editor-title',
  TEXT_EDITOR_H1 = 'text-editor-h1',
  TEXT_EDITOR_H2 = 'text-editor-h2',
  TEXT_EDITOR_H3 = 'text-editor-h3',
  TEXT_EDITOR_H4 = 'text-editor-h4',
  TEXT_EDITOR_H5 = 'text-editor-h5',
  TEXT_EDITOR_BODY = 'text-editor-body',

  HEADLINE_H1 = 'headline-h1',
  HEADLINE_H2 = 'headline-h2',
  HEADLINE_H3 = 'headline-h3',
  HEADLINE_H4 = 'headline-h4',

  LABEL_1_REGULAR = 'label-1-regular',
  LABEL_1_SEMIBOLD = 'label-1-semibold',
  LABEL_2_REGULAR = 'label-2-regular',
  LABEL_2_SEMIBOLD = 'label-2-semibold',

  BODY_1_REGULAR = 'body-1-regular',
  BODY_1_BOLD = 'body-1-bold',
  BODY_2_REGULAR = 'body-2-regular',
  BODY_2_BOLD = 'body-2-bold',

  CAPTION_REGULAR = 'caption-regular',
  CAPTION_BOLD = 'caption-bold',

  MICRO_REGULAR = 'micro-regular',
  MICRO_BOLD = 'micro-bold',

  EXPRESSIVE_H1 = 'expressive-h1',
  EXPRESSIVE_H2 = 'expressive-h2',
  EXPRESSIVE_H3 = 'expressive-h3',
}

type TypographyProps = {
  variant: Typographies;
  tag?: keyof React.JSX.IntrinsicElements;
  children: ReactNode;
  className?: string;
};

const Typography: FC<TypographyProps> = ({ variant, tag: Tag = 'div', className, children }) => (
  <Tag className={clsx(styles.typography, styles[variant], className)}>{children}</Tag>
);

export { Typography, Typographies, type TypographyProps };
